"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeLessonContent = exports.getPreviousLesson = exports.getNextLesson = void 0;
var _lodash = require("lodash");
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var sanitizeLessonContent = function sanitizeLessonContent(rawContent) {
  if ((0, _lodash.isNil)(rawContent)) {
    return null;
  }
  return (0, _sanitizeHtml.default)(rawContent, {
    allowedTags: _sanitizeHtml.default.defaults.allowedTags.concat(['iframe']),
    allowedAttributes: {
      // We don't allow 'width' and 'height' attributes for iframe tags here,
      // it is always purged on sanitize and we can always control the video size with our styles
      iframe: ['style', 'allowfullscreen', 'frameborder', 'src'],
      a: ['href', 'rel', 'target'],
      div: ['class', 'style', 'id']
    },
    allowedIframeHostnames: [process.env.REACT_APP_LESSONS_ALLOWED_VIDEO_HOST]
  });
};
exports.sanitizeLessonContent = sanitizeLessonContent;
var getPreviousLesson = function getPreviousLesson(selectedLesson, lessons) {
  var selectedLessonIndex = getSelectedLessonIndex(selectedLesson, lessons);
  return (0, _lodash.isNumber)(selectedLessonIndex) && selectedLessonIndex >= 1 ? lessons[selectedLessonIndex - 1] : undefined;
};
exports.getPreviousLesson = getPreviousLesson;
var getSelectedLessonIndex = function getSelectedLessonIndex(selectedLesson, lessons) {
  var lessonsCount = lessons.length;
  if (lessonsCount < 2) {
    return undefined;
  }
  return (0, _lodash.findIndex)(lessons, function (lesson) {
    return lesson.slug === selectedLesson.slug;
  });
};
var getNextLesson = function getNextLesson(selectedLesson, lessons) {
  var selectedLessonIndex = getSelectedLessonIndex(selectedLesson, lessons);
  return (0, _lodash.isNumber)(selectedLessonIndex) && selectedLessonIndex < lessons.length - 1 ? lessons[selectedLessonIndex + 1] : undefined;
};
exports.getNextLesson = getNextLesson;